import { useMemo } from 'preact/compat'

import { useFetchFromHarvestApp as fetch } from './useApi'

export default function () {
  const { result, error, loading } = fetch('/platform/project_assignments')

  const sortedProjects = useMemo(() => {
    const projects = []

    if (result) {
      for (const [projectId, projectValue] of Object.entries(result.projects)) {
        const projectTasks = []

        for (const [taskId, taskValue] of Object.entries(
          projectValue.task_assignments
        )) {
          const parsedTaskId = parseInt(taskId)
          const task = {
            id: parsedTaskId,
            name: result.tasks[parsedTaskId].name,
            billable: taskValue.billable === 1,
          }

          projectTasks.push(task)
        }

        const project = {
          id: parseInt(projectId),
          name: projectValue.name,
          code: projectValue.code,
          sort_name: `${result.clients[projectValue.client_id].name}${
            projectValue.code || ''
          }${projectValue.name}`.toLowerCase(),
          client: {
            name: result.clients[projectValue.client_id].name,
          },
          tasks: projectTasks.sort((a, b) =>
            a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
          ),
        }

        projects.push(project)
      }
    }

    return projects.sort((a, b) => (a.sort_name < b.sort_name ? -1 : 1))
  }, [result])

  return {
    projects: sortedProjects,
    error,
    loading,
  }
}
